<ng-template #linkContent>
  <ng-content />
  <span class="truncate-text">{{ $displayText() }}</span>
</ng-template>

<!-- [routerLink] disables href if present (even `undefined`), this ugly control switch separates behavior -->
@if ($isHref()) {
  <a class="base-link" [href]="$link()" [title]="$link()">
    <ng-container *ngTemplateOutlet="linkContent" />
  </a>
} @else {
  <a class="base-link" [routerLink]="$link()" [title]="$link()">
    <ng-container *ngTemplateOutlet="linkContent" />
  </a>
}
